const Alternative = () => (
  <li className="PropertyAccess__item big-text">
    If you do not want to continue using digital checkin,
    you will see a set of keys inside the flat which you can
    use alternatively.
  </li>
);

export default Alternative;
